(() => {
  const applyFixes = () => {
    document.querySelectorAll('elfine-viewer-counter').forEach((counter) => {
      const count = counter.querySelector('[data-viewer-count]');
      const line = count?.parentElement;
      if (!count || !line) return;
      [...line.childNodes].forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });
      line.append(document.createTextNode(' people are viewing this right now'));
    });

    document.querySelectorAll('elfine-whatsapp-order').forEach((order) => {
      order.dataset.greeting = 'Hello Elfine, I would like to order:';
      order.dataset.optionLabel = 'Size';
      order.dataset.quantityLabel = 'Quantity';
      const button = order.querySelector('.elfine-order-button');
      if (button) {
        [...button.childNodes].forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) node.remove();
        });
        button.append(document.createTextNode(' Order on WhatsApp'));
      }
    });

    document.querySelectorAll('.elfine-summary-heading').forEach((heading) => {
      const title = heading.querySelector('h2');
      const hint = heading.querySelector('p');
      if (title) title.textContent = 'Order summary';
      if (hint) hint.textContent = 'Discounts, shipping and taxes are calculated at checkout.';
    });

    document.querySelectorAll('.elfine-cart-reassurance').forEach((list) => {
      const labels = list.querySelectorAll('li span');
      if (labels[0]) labels[0].textContent = 'Secure checkout';
      if (labels[1]) labels[1].textContent = 'Easy exchanges';
      if (labels[2]) {
        const country = window.Shopify?.country || document.documentElement.dataset.country || '';
        labels[2].textContent = country === 'PK' ? 'Delivery nationwide' : 'Worldwide delivery';
      }
    });
  };

  const style = document.createElement('style');
  style.textContent = '.cart-page .cart-items__media .cart-items__media-container{background:#fff!important}.cart-page .cart-items__media-image{background:#fff!important}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes, { once: true });
  } else {
    applyFixes();
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyFixes();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
